module.exports = __webpack_public_path__ + "static/media/hourglass-ended_grey_big.77878b1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/hourglass-ended_grey_big.png
// module id = ./src/assets/media/icons/hourglass-ended_grey_big.png
// module chunks = 16